import { render, staticRenderFns } from "./ProductionRunsTable.vue?vue&type=template&id=2fba60bd&scoped=true"
import script from "./ProductionRunsTable.vue?vue&type=script&lang=js"
export * from "./ProductionRunsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductionRunsTable.vue?vue&type=style&index=0&id=2fba60bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba60bd",
  null
  
)

export default component.exports